(() => {
  const normalize = value => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss').replace(/[-_]/g, ' ').replace(/\s+/g, ' ').trim();
  const fault = value => {
    const s = normalize(value);
    if (/wasser|flussig|kaffee|korrosion|getrank/.test(s)) return 'water';
    if (/datenrett|daten retten|daten wieder|forensik|speicher|ssd|festplatte/.test(s)) return 'data';
    if (/nur am kabel|akku|batterie/.test(s)) return 'battery';
    if (/display|bildschirm|glasbruch|frontglas|touchscreen|flexgate|beleuchtung/.test(s)) return 'display';
    if (/trackpad|touchpad|tastatur|keyboard/.test(s)) return 'input';
    if (/lade|ladt|laden|magsafe|usb c|usb port|anschluss/.test(s)) return 'charge';
    if (/kamera|camera|linsen|linse/.test(s)) return 'camera';
    if (/ruckseite|backcover|gehause|rahmen/.test(s)) return 'back';
    if (/geht nicht|startet nicht|lasst sich nicht einschalten|kein bild|keine funktion|schwarzer bildschirm|kurzschluss|logicboard|mainboard|platine|prozessor|bga|reball|chip|uberhitz|neustart|bootloop|restart/.test(s)) return 'board';
    return null;
  };
  const accessoryKind = value => {
    const s = normalize(value);
    if (/ersatzspitz|stiftspitz|pencil spitz/.test(s)) return 'tips';
    if (/pencil|eingabestift|stylus|stift/.test(s) && !/kabel|stecker|netzteil|ladegerat|charger|tasche|hulle|case|tastatur|keyboard/.test(s)) return 'pencil';
    if (/stecker|netzteil|ladegerat|charger/.test(s)) return 'charger';
    if (/kabel|adapter|usb/.test(s)) return 'cable';
    if (/tastatur|keyboard/.test(s)) return /touch|trackpad/.test(s) ? 'keyboardTouch' : 'keyboard';
    if (/tasche|digital bag/.test(s)) return 'bag';
    if (/folie|panzerglas|schutzglas|displayschutz/.test(s)) return /ipad|tablet/.test(s) ? 'tabletGlass' : 'film';
    if (/hulle|case/.test(s)) return /ipad|tablet/.test(s) ? 'tabletCase' : 'phoneCase';
    if (/pencil|eingabestift|stylus|stift/.test(s)) return 'pencil';
    if (/zubehor|zubehoer|ausstattung|clazo/.test(s)) return 'accessories';
    return null;
  };
  const classify = value => {
    const s = normalize(value);
    const kind = accessoryKind(s);
    const service = /repar|datenrett|kurzschluss|wasserschaden|defekt|kaputt|geht nicht|startet nicht|bleibt nur|ladt nicht|ladebuchse|ladeport|lade ic|akkuwechsel|batteriewechsel|displaytausch|display wechsel|tauschen|akkutausch|uberhitz/.test(s);
    const accessory = !!kind && !service;
    let family = null;
    if (/grafikkart|graphics|\bgpu\b|geforce|radeon/.test(s)) family = 'gpu';
    else if (/\bswitch\b|playstation|xbox/.test(s)) family = 'console';
    else if (/macbook/.test(s)) family = 'mac';
    else if (/imac/.test(s)) family = 'imac';
    else if (/ipad|tablet|surface/.test(s)) family = 'tablet';
    else if (/laptop|notebook|dell|lenovo/.test(s)) family = 'laptop';
    else if (/computer|\bpc\b|mac mini/.test(s)) family = 'desktop';
    else if (/iphone/.test(s)) family = 'iphone';
    else if (/handy|smartphone|samsung|galaxy|google|pixel|xiaomi|redmi|huawei|honor|oppo|oneplus|poco|akkuwechsel|\bx cover\b|\bnote\b/.test(s)) family = 'phone';
    else if (/datenrett|forensik|daten retten/.test(s)) family = 'storage';
    else if (/display|akku|apple|reparaturservice|mediamarkt/.test(s)) family = 'phone';
    return { accessory, kind: accessory ? kind : null, family, fault: accessory ? null : fault(s) };
  };
  const selectPhoto = (context, heading, fallback = false) => {
    const page = classify(context);
    if (page.accessory) return { productKind: accessoryKind(heading) || page.kind };
    const section = normalize(heading);
    if (!fallback && /^(kosten|preise|ablauf|haufige fragen|weitere passende|kontakt|reparatur anfragen|bestellung)/.test(section)) return null;
    const f = fault(section) || page.fault;
    const family = page.family;
    if (family === 'gpu') return { key: /bga|reball|lotstation/.test(section) ? 'bga' : 'gpu' };
    if (family === 'console') return { key: 'consoleBattery' };
    if (family === 'mac') {
      const key = ({ water: 'macWater', data: 'macData', battery: 'macOpen', display: 'macDisplay', input: 'macInput', charge: 'macMicroscope', board: 'macBoard' })[f] || 'macMicroscope';
      return { key };
    }
    if (family === 'imac') return { key: f === 'display' ? 'imacDisplay' : 'imacBoard' };
    if (family === 'laptop') return { key: 'laptopBoard' };
    if (family === 'desktop') return { key: /mac mini/.test(normalize(context)) ? 'macMiniBoard' : 'desktopBoard' };
    if (family === 'tablet') return { key: ({ water: 'tabletWater', battery: 'tabletBattery', charge: 'tabletCharge', display: 'tabletDisplay', data: 'data' })[f] || 'tabletOpen' };
    if (family === 'storage') return { key: 'data' };
    if (family === 'iphone' || family === 'phone') {
      const key = ({ water: 'phoneWater', display: 'display', battery: 'phoneBattery', charge: 'phoneCharge', camera: 'phoneCamera', back: family === 'iphone' ? 'iphoneBack' : null, data: family === 'iphone' ? 'iphoneBoard' : 'androidBoard', board: family === 'iphone' ? 'iphoneNoPower' : 'androidBoard' })[f];
      return key ? { key } : { key: family === 'iphone' ? 'iphoneNoPower' : 'androidBoard' };
    }
    return null;
  };
  globalThis.HsSeoTopics = { normalize, classify, accessoryKind, selectPhoto };
})();
